/** Turns the HTML one export cell rendered into the text written to the file. */
export type ExportHtmlToText = (html: string) => string;

/**
 * Markup with no tags, entities, carriage returns or NUL characters parses to
 * itself, so it can skip the HTML parser. Most cells are plain text, and
 * parsing every one of them is the slow part of a large export.
 */
export const isPlainExportText = (html: string): boolean =>
  !/[<&\r\0]/.test(html);

/**
 * Browser version: parses the markup in a detached element and reads its
 * text. The server has no `document`, so it passes its own implementation.
 */
export const browserExportHtmlToText: ExportHtmlToText = (html) => {
  const documentFragment = document.createElement("div");
  documentFragment.innerHTML = html;
  return documentFragment.innerText.trim();
};
